import { useEffect, useMemo, useState } from "react";
import { FieldRow, TextInput } from "components/cms/fields";

const NEW = "__new__";

const slugify = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export default function CategoryPicker({
  label,
  slugPath,
  labelPath,
  form,
  setField,
  frMap,
  loadOptions,
  newLabel = "Add new",
}) {
  const [options, setOptions] = useState([]);
  const [isNew, setIsNew] = useState(false);
  const currentSlug = form[slugPath] || "";
  const currentLabel = form[labelPath] || "";

  useEffect(() => {
    let cancelled = false;
    loadOptions()
      .then((items) => {
        if (!cancelled) setOptions(items || []);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [loadOptions]);

  const merged = useMemo(() => {
    if (currentSlug && !options.some((item) => item.slug === currentSlug)) {
      return [...options, { slug: currentSlug, label: currentLabel || currentSlug }];
    }
    return options;
  }, [options, currentSlug, currentLabel]);

  const onSelect = (value) => {
    if (value === NEW) {
      setIsNew(true);
      setField(slugPath, "");
      setField(labelPath, "");
      return;
    }
    setIsNew(false);
    const option = merged.find((item) => item.slug === value);
    setField(slugPath, option?.slug || value);
    setField(labelPath, option?.label || "");
  };

  return (
    <>
      <div>
        <label htmlFor={slugPath} className="text-xs font-semibold text-navy-700 dark:text-white">
          {label}
        </label>
        <select
          id={slugPath}
          className="mt-1 h-10 w-full rounded-lg border border-gray-200 bg-white px-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
          value={isNew ? NEW : currentSlug}
          onChange={(event) => onSelect(event.target.value)}
        >
          <option value="">{`Select ${label.toLowerCase()}`}</option>
          {merged.map((item) => (
            <option key={item.slug} value={item.slug}>
              {item.label}
            </option>
          ))}
          <option value={NEW}>{newLabel}</option>
        </select>
      </div>
      {isNew ? (
        <FieldRow>
          <TextInput
            label={`${label} slug`}
            path={slugPath}
            form={form}
            setField={setField}
            placeholder="ai-ml"
          />
          <TextInput
            label={`${label} label`}
            path={labelPath}
            form={form}
            setField={(path, value) => {
              setField(path, value);
              if (path === labelPath) setField(slugPath, slugify(value));
            }}
            frMap={frMap}
          />
        </FieldRow>
      ) : null}
    </>
  );
}
